import React from "react";
import Header from "./Header";

interface Props extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
}

function MediumHeader(props: Props) {
  return (
    <Header level={2} {...props}>
      {props.children}
    </Header>
  );
}

export default MediumHeader;
